import { Command } from '../Commands';

export class CorporateAddMedia extends Command {
  type: string = 'CorporateAddMedia';

  priority: number = 100;
}
